
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./basics-3-big-picture.json") })
        }
      }, "path---basics-3-big-picture");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---basics-3-big-picture!./.cache/json/basics-3-big-picture.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---basics-3-big-picture!./.cache/json/basics-3-big-picture.json
// module chunks = 154